// Directives
import '../../aam-framework/js/directives/hires-bg';
import '../../aam-framework/js/directives/equalize-height';

// Components
import '../../aam-framework/js/components/accordion.js';
import '../../aam-framework/js/components/bleeding-gallery.js';
import '../../aam-framework/js/components/bleeding-slider.js';
import '../../aam-framework/js/components/card-feed.js';
import '../../aam-framework/js/components/card-grid-feature.js';
import '../../aam-framework/js/components/card-slider.js';
import '../../aam-framework/js/components/cards.js';
import '../../aam-framework/js/components/header.js';
import '../../aam-framework/js/components/mailchimp.js';
import '../../aam-framework/js/components/map-embed.js';
import '../../aam-framework/js/components/offscreen-menu.js';
import '../../aam-framework/js/components/pricing-table.js';
import '../../aam-framework/js/components/scroll-nav.js';
import '../../aam-framework/js/components/select.js';
import '../../aam-framework/js/components/shop-cards.js';
import '../../aam-framework/js/components/swiftype.js';
import '../../aam-framework/js/components/tabbed-thumb-grid.js';
import '../../aam-framework/js/components/translation-dropdown.js';
import 'components/hero-calendar';
import '../../aam-framework/js/components/posts-filter.js';

// Templates
import 'templates/archive-aam__events';
import 'templates/single-aam__events';
import 'templates/calendar-home-alt';

console.log('calendar main');
